export const APP_VERSION = "V 5.0.0";

/** Keys stored on each external integration endpoint; labels for UI dropdowns */
export const EXTERNAL_INTEGRATION_ENDPOINT_TYPES = {
  fetch_order_by_id: "Fetch Order By ID",
  upload_pdf_result: "Upload PDF Result",
};

export const EXTERNAL_INTEGRATION_ENDPOINT_TYPE_KEYS = Object.keys(
  EXTERNAL_INTEGRATION_ENDPOINT_TYPES
);

/** HTTP verb the portal uses when calling each endpoint type (keep in sync with backend). */
export const EXTERNAL_INTEGRATION_ENDPOINT_HTTP_METHODS = {
  fetch_order_by_id: "GET",
  upload_pdf_result: "POST",
};

/** In fetch URLs we replace this token with the real order id when calling your API. */
export const EXTERNAL_INTEGRATION_ORDER_ID_PLACEHOLDER = "{ORDER_ID}";

/** @deprecated Legacy token; still replaced when building fetch URLs */
export const EXTERNAL_INTEGRATION_ORDER_ID_PLACEHOLDER_LEGACY = "{{ORDER_ID}}";

/** `multipart/form-data` part names for upload_pdf_result (POST to client URL). */
export const EXTERNAL_INTEGRATION_SUBMIT_FORM_FIELDS = {
  orderId: "orderId",
  resultPdf: "resultPdf",
};

export const COC_STATUS = {
    PENDING: "pending",
    RECEIVED: "received",
    ANALYSED: "analysed",
    DA_REQUESTED: "da-requested",
    DA_COMPLETED: "da-completed",
};